import styled from "@emotion/styled"

export const BannerWrapper = styled.aside`
  grid-column: 1 / span 14;
  background: ${p => p.theme.colors.grayDark};
  color: ${p => p.theme.colors.white};
  text-align: center;
  font-size: ${p => p.theme.fontSizes[1]};
  padding: ${p => p.theme.space[2]} 0;

  button {
    text-decoration: underline;
  }

  @media ${p => p.theme.mq.mobileM} {
    margin-top: 72px;
    margin-bottom: 0;
    font-size: 10px;
    padding: ${p => p.theme.space[2]} 16px;
  }
`
